module.exports = __webpack_public_path__ + "static/img/women.89602029.jpg";